import { render } from "./ResearchTreePanel.vue?vue&type=template&id=77b446fa&scoped=true"
import script from "./ResearchTreePanel.vue?vue&type=script&lang=js"
export * from "./ResearchTreePanel.vue?vue&type=script&lang=js"

import "./ResearchTreePanel.vue?vue&type=style&index=0&id=77b446fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b446fa"]])

export default __exports__